/* eslint-disable no-undef */

import { useConfigurationStore } from '@/stores/configurationModule';
import findProductPriceByQuantity from '@/utils/findProductPriceByQuantity';
import { findProductPriceIndexByQuantity } from '@/utils/findProductPriceByQuantity';
function preprocessCartItems(items = []) {
  return items;
}
export const useCartStore = defineStore('cartStore', () => {
  const {
    configurationId,
    boxQuantity
  } = storeToRefs(useConfigurationStore());
  const baseQuantity = 100;
  const cart = ref([]);
  const productPrice = ref(0);
  const productPricesObject = ref({});
  const prices = computed(() => productPricesObject?.value?.quantity_pricing || []);
  const basePrice = computed(() => {
    const value = findProductPriceByQuantity(prices.value, baseQuantity);
    return value?.price || 0;
  });
  const currentProductPrice = computed(() => {
    const value = findProductPriceByQuantity(prices.value, boxQuantity.value);
    return value?.price || '';
  });
  const nextLowerPrice = computed(() => {
    const index = findProductPriceIndexByQuantity(prices.value, boxQuantity.value);
    if (index === null) return '';
    if (index + 1 > prices.value.length - 1) return '';
    return prices.value[index + 1];
  });
  const boxQuantityOptions = computed(() => {
    if (prices.value && prices.value.length > 0) {
      return prices.value.map(item => {
        return {
          pcs: item.min,
          price: item.price
        };
      });
    }
    const numOfOptions = 10;
    const step = 25;
    return Array.from({
      length: numOfOptions
    }, (_, i) => {
      const pcs = (i + 1) * step;
      let priceObj = {
        price: 0
      };
      if (prices.value && prices.value.length) {
        priceObj = findProductPriceByQuantity(prices.value, pcs);
      }
      return {
        pcs,
        price: priceObj?.price || 0
      };
    });
  });
  const cartItems = computed(() => preprocessCartItems(cart.value));

  // const ABORT = true
  const currentCartItem = computed(() => {
    // if (ABORT) return null
    if (!cartItems.value?.length) return null;
    return cartItems.value.find(item => item?.meta_data?.configuration_id === configurationId.value);
  });
  const isUpsellUsed = computed(() => {
    return currentCartItem.value?.meta_data?.is_upsell || false;
  });
  const setCart = payload => {
    cart.value = payload;
  };
  const setProductPricesObject = payload => {
    productPricesObject.value = payload;
  };
  const setProductPrice = payload => {
    productPrice.value = payload;
  };
  return {
    cart,
    productPrice,
    productPricesObject,
    cartItems,
    currentCartItem,
    currentProductPrice,
    nextLowerPrice,
    boxQuantityOptions,
    basePrice,
    isUpsellUsed,
    setCart,
    setProductPrice,
    setProductPricesObject
  };
});